import { DataModel } from "common/models/utility-models/base-model";
import { RegisterStep1Model } from "../Step1-model/step1-data-model";
import { RegisterStep2Model } from "../Step2-model/step2-data-model";
import { RegisterStep3Model } from "../Step3-model/step3-data-model";
import { RegisterStep4Model } from "../Step4-model/step4-data-model";
import { RegisterStep5Model } from "../Step5-model/step-5-data-model";


export class RegisterModel extends DataModel {
    step1: RegisterStep1Model = new RegisterStep1Model();
    step2: RegisterStep2Model = new RegisterStep2Model();
    step3: RegisterStep3Model = new RegisterStep3Model();
    step4: RegisterStep4Model = new RegisterStep4Model();
    // step5: RegisterStep5Model = new RegisterStep5Model();
    // trigger_submit:string="";
    isButtonEnabled : boolean = true;
    studentApplicationId:string='';
    
 }